export enum ImagesPaths {
  LOGO_PNG = '/assets/icons/icon-128x128.png',
}
